module.exports = __webpack_public_path__ + "media/images/icons/country_flags/mg-5d294de1198203cd569a8f35ccae38e4.svg";